/**
 * @file: SendSms.
 * @authors: fjxhx.
 * @createDate: 2022.
 * @Description: 短信发送
 */
import request from '@/utils/request'

/**
 * 业务平台短信发送
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function smsInitSmsSend(data) {
  return request({
    type: 'biz',
    url: 'sms/init/sms/send',
    method: 'post',
    data
  })
}

/**
 * 业务平台短信发送
 * @author: fjxhx
 * @createDate: 2022
 * @param data {Object} 参数
 */
export function smsSend(data) {
  return request({
    type: 'biz',
    url: 'sms/send',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/SendSms.js